import EncryptionUtils from "./encryptionUtils";
export function buildUserPayload(): | null | { field: string; operator: string; value: string } {
  const email = localStorage.getItem("email")
  const { role } = EncryptionUtils.getAuthInfo();
  if (!role || !email) return null;
  const lowerRole = role.toLowerCase().replace(/\s+/g, "");
  const skipRoles = ["admin", "primaryspoc", "secondaryspoc", "superadmin"];
  if (skipRoles.includes(lowerRole)) return null;
  if (lowerRole === "auditor") {
    const userInfo = EncryptionUtils.get<any>("userInfo", null);
    if (!userInfo) return null;
    try {
      const isPrimary = userInfo?.isPrimaryAuditor;
      return {
        field: isPrimary ? "primaryAuditorName" : "secondaryAuditorName",
        operator: "=",
        value: email
      };
    } catch (error) {
      console.error("Failed to parse userInfo:", error);
      return null;
    }
  }
  const formattedRole =
    role
      .split(" ")
      .map((word, index) =>
        index === 0
          ? word.toLowerCase()
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join("") + "Email";
  return {
    field: formattedRole,
    operator: "=",
    value: email,
  };
}